import { useCallback, useEffect, useState } from "react";

/**
 * Winziger Router über die History-API. Bewusst keine Bibliothek: die App hat
 * drei Wege, und jede Abhängigkeit weniger ist ein Startvorgang weniger im
 * Offline-Betrieb.
 */
export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function useRoute(): string {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const update = () => {
      setPath(window.location.pathname);
    };
    window.addEventListener("popstate", update);
    return () => {
      window.removeEventListener("popstate", update);
    };
  }, []);

  return path;
}

/** Liefert die ID aus "/liste/<id>", sonst null. */
export function listIdFromPath(path: string): string | null {
  const match = /^\/liste\/([^/]+)$/u.exec(path);
  return match?.[1] ?? null;
}

/** Liefert die ID aus "/einkauf/<id>", sonst null. */
export function shoppingListIdFromPath(path: string): string | null {
  const match = /^\/einkauf\/([^/]+)$/u.exec(path);
  return match?.[1] ?? null;
}

/** Liefert die ID aus "/rezept/<id>", sonst null. */
export function recipeIdFromPath(path: string): string | null {
  const match = /^\/rezept\/([^/]+)$/u.exec(path);
  return match?.[1] ?? null;
}

/** Liefert die ID aus "/produkt/<id>", sonst null. */
export function productIdFromPath(path: string): string | null {
  const match = /^\/produkt\/([^/]+)$/u.exec(path);
  return match?.[1] ?? null;
}

export function useNavigate(): (path: string) => void {
  return useCallback((path: string) => {
    navigate(path);
  }, []);
}
